snt-blog-feature-articles {
  display: block;
  width: 100%;
  /**
    * CSS-only carousel implementation
    * https://css-tricks.com/simple-swipe-with-vanilla-javascript/
    **/
  & > div.spacings {
    @include layout();
    overflow-x: scroll;
    overflow-y: hidden;
    scroll-snap-type: x mandatory;
    scroll-behavior: smooth;
    display: flex;
    /**
              Fix for flex container with horizontal overflow scroll padding not applied to flex end side of container
              * https://chenhuijing.com/blog/flexbox-and-padding/
              */

    > * {
      scroll-snap-align: center;
      flex: 0 0 calc(100% - 2em);
      margin: 0 1em;
      &:first-child {
        flex: 0 0 calc(100% - 1em);
        margin: 0 1em 0 0;
      }
      &:last-child {
        flex: 0 0 calc(100% - 1em);
        margin: 0 0 0 1em;
      }
    }
  }
  @include viewport($viewport-md) {
    & > div.spacings {
      overflow-x: hidden;
      display: grid;
      grid-template-columns: repeat(2, 1fr);
      grid-template-rows: repeat(2, 1fr);
      column-gap: 1.87rem;
      row-gap: 1.875rem;
      > * {
        margin: 0 !important;
        &:first-child {
          grid-column: 1;
          grid-row: 1 / 3;
        }
      }
    }
  }
}
